; (function (global, factory) {
    typeof define === 'function' && define.amd
        ? define('MM/Utils/UrlHelper',["jquery", "score_bootstrap/Utils/UrlHelper"], factory)
        : typeof exports === 'object' && typeof module !== typeof void 0
            ? module.exports = factory(require("jquery"), require("score_bootstrap/Utils/UrlHelper"))
            : console && console.error('UrlHelper does not support non-amd script loading.');
}(this /* window */,
    function ($, ScoreUrlHelper) {

        var defaultHashDelimiter = "/";

        function UrlHelper() {
            // Override
            // ScoreUrlHelper.prototype.setUrlParameters = UrlHelper.setUrlParameters;
            // ScoreUrlHelper.prototype.getHashAsObject = UrlHelper.getHashAsObject;
            // ScoreUrlHelper.call(this);
            // return undefined;
        }

        for (var k in ScoreUrlHelper) {
            UrlHelper.prototype[k] = ScoreUrlHelper[k];
        }

        UrlHelper.prototype.createSetRegExp = function createSetRegExp(urlParam) {
            /*
            [\?|&]                      Character set - Match any of these characters: [?|&]
            (urlParam=[^&]+|$)          Capturing parenthesis. (x) matches x and remembers the match.
                urlParam=               Explicit match
                [^&]+                   Negated character set. The + quantifier causes this item to be matched 1 or more times (greedy).
                |                       Or
                $                       Matches end of input.
            */
            return new RegExp("([\?|&])(" + urlParam + "=[^&#]+|$)", "gi");
        };

        UrlHelper.prototype.createGetRegExp = function createGetRegExp(urlParam) {
            return new RegExp("[\?|&]" + urlParam + "=([^&#]+|$)", "gi");
        };

        UrlHelper.prototype.getHashAsObject = function getHashAsObject(delimiter) {

            // First check if the hash contains the value: facet=
            // If it does then we want the part containing the 'facet=' value
            // That information is then used under the following area to get the SCORE search facet values
            // \Areas\ScoreBootstrapUI\js\Components\ContentSearch\FacetContainer.js
            var facetToken = "facet=";

            // If the facetToken does NOT exist then by default just use what is in hash
            // Ex: <domain_name>/news-events#news
            // returns 'news'
            var hashValueToUse = window.location.hash.slice(1);

            // If the facetToken does exist then grab that value
            // Ex: <domain_name>/news-events#news#73abc91c-8eb2-44d1-87b2-429b09e3c720facet=Region:MAUS%7CMWUS
            // returns '73abc91c-8eb2-44d1-87b2-429b09e3c720facet=Region:MAUS%7CMWUS'
            if (window.location.hash.indexOf(facetToken) >= 0) {
                var arr = window.location.hash.slice(1).split('#');
                $.each(arr, function (index, value) {
                    if (value.indexOf(facetToken) >= 0)
                        hashValueToUse = value;
                });
            }

            var hashObj = decodeURI(hashValueToUse)
                .split(delimiter || defaultHashDelimiter)
                .reduce(function (result, value) {
                    value = value.split("=");
                    if (value.length === 2) {
                        result[value[0]] = value[1];
                    }

                    return result;
                }, {});

            return hashObj;
        };

        UrlHelper.prototype.getObjectAsHash = function getObjectAsHash(obj, delimiter) {
            var hash = "", del = delimiter || defaultHashDelimiter;
            $.each(obj, function (key, value) {
                hash = hash + key + "=" + value + del;
            });

            return encodeURI(hash.substring(0, hash.length - del.length)); // cut off trailing delimiter
        };

        UrlHelper.prototype.getHashValue = function getHashValue(paramName, delimiter) {
            return this.getHashAsObject(delimiter || defaultHashDelimiter)[paramName];
        };

        UrlHelper.prototype.setHashValue = function setHashValue(location, paramName, value, delimiter) {
			/**
			 * location    - required, https://developer.mozilla.org/en-US/docs/Web/API/Location item
			 * paramName   - required, parameter name
			 * value       - required, parameter value
			 * delimeter   - optional, character delimiting hash parameters
			 */

            if (typeof (location.hash) !== "string") {
                throw new Error("location must implement Location");
            }

            var hash = this.getHashAsObject(delimiter);
            if (!value) {
                delete hash[paramName];
            } else {
                hash[paramName] = value;
            }

            var locationHashValue = this.getObjectAsHash(hash, delimiter || defaultHashDelimiter);

            // This will keep the 'news' tabset hash data
            //Score Content search adds facet value to the url 
            if (window.location.hash.indexOf('news') >= 0 && window.location.hash.indexOf('news#') > 0) {
                //Computed url from BackToSearch.js matches this
                locationHashValue = 'news#' + locationHashValue;
            }

            // This will keep the 'events' tabset hash data
            //Score Content search adds facet value to the url 
            if (window.location.hash.indexOf('events') >= 0 && window.location.hash.indexOf('events#') > 0) {
                //Computed url from BackToSearch.js matches this
                locationHashValue = 'events#' + locationHashValue;
            }

            // This works and might be the one to use but it also doesn't trigger a 
            // onhashchange event so it might potentially cause other issues.  Since
            // that is the case I am going to use the other one but keep this just in case.
            // history.replaceState(undefined, undefined, '#' + locationHashValue);

            // Use window.location.href.replace instead of location.hash in order to not add the url to the window.history object
            // when location.hash is used it might add quite a few urls to the history causing the user to be annoyed by having to 
            // click the back button in the browser multiple times in order to get to the page before the hashes were loaded
            var baseUrl = window.location.href.split('#')[0];
            window.location.replace(baseUrl + '#' + locationHashValue);
        };

        // Inherit prototype methods
        UrlHelper.prototype.setUrlParameters = function setUrlParameter(location, urlParam, value) {
            value = encodeURIComponent(value);
            if (location === undefined || location === null) {
                throw new Error("No location URL implemented");
            }

            var regExp = this.createSetRegExp(urlParam);
            var url = location.href;

            // remove hash from location.href, since it can be a window.location.href, as well as a "a" HTML element.
            // later on we will restore hash from the window.location.href
            url = url.replace(/\#.+/, '');

            // Remove anchor
            var anchor = '';
            var hashPosition = window.location.href.indexOf('#');

            if (~hashPosition) {
                anchor = window.location.href.substring(hashPosition + 1);

                // This is needed to fix an IE 11 issue
                if (anchor.indexOf('?') > -1)
                    anchor = '';
            }

            // Clear out all current instances of this param in the query string
            if (regExp.test(url)) {
                url = url.replace(regExp, "$1");
                // If query string was something like ?param=value&otherparam=othervalue and ew removed param=value then we would end up with ?&
                if (url.indexOf("?&") > -1) {
                    url = url.replace("?&", "?");
                }
                if (url.indexOf("&&") > -1) {
                    url = url.replace("&&", "&");
                }
            }

            if (value) {
                if (url.indexOf("?") < 0) {
                    url += "?";
                } else if (new RegExp("[\?&]").test(url.slice(-1)) === false) {
                    url += "&";
                }
                url += (urlParam + "=" + value);
            }

            // IPA-994: Search by text query cannot be triggered if filter has preselected values in it
            // In case we press 'Enter' or click on the 'Search' button we redirect without hash
            var buttonConditions = location.classList && location.classList.contains("score-button") || false;
            // IPA-682 (part #3). If it is a simple anchor - leave the hash part, otherwise erase the hash part because it might have Facet filter
            var isSimpleAnchor = !/[=&]/.test(anchor);

            // Append anchor back to url
            if (~hashPosition && (!buttonConditions || isSimpleAnchor) && anchor !== '') {
                url += '#' + anchor;
            }


            if (window.location.pathname === location.pathname) {
                window.history.replaceState(null, document.title, url);
            }
            return url;
        };

        //This method in Score Util file removes hash value from url 
        //Method extended to keep the history for loading the correct facets in search result pages especially for News-Events page
        UrlHelper.prototype.removeHash = function () {
            var scrollV, scrollH, loc = window.location;

            if (history.pushState.length) {
                history.pushState("", document.title, loc.pathname + loc.search);
            } else {
                // Prevent scrolling by storing the page's current scroll offset
                scrollV = $(window).scrollTop();
                scrollH = $(window).scrollLeft();

                loc.hash = ""

                // Restore the scroll offset, should be flicker free
                $(window).scrollTop(scrollV);
                $(window).scrollLeft(scrollH);
            }
        };
        return new UrlHelper(); // Singleton
    }));

